module.exports = __webpack_public_path__ + "static/productLogisticsControl-851039c78e1258b1711e88d081a95c7b.jpg";